import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import { CourseModule } from '@/store/modules/course'
  import useCourse from '@/composables/useCourse'
  import CookieHelper from '@/helpers/CookieHelper'
  import useSegment from '@/composables/useSegment'
  import useGamification from '@/composables/useGamification'
  import { useRouter } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'
  import useCommonMixin from '@/composables/useCommonMixin'
  import * as Sentry from '@sentry/vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExamResults',
  setup(__props) {

  const router = useRouter()
  const { course, currentCourseId, examCompletionIdParam } = useCourse()
  const { trackPage, pageViewed } = useSegment()
  const { trackGamificationActivity } = useGamification()
  const { translateString } = useI18n()
  const { isKnowledgeCheckCompany } = useCommonMixin()

  const loadingResults = computed(() => examResult.value === null || !examResult.value?.parts)

  const examResult = computed(() => CourseModule.examResult)

  const courseExam = computed(() => {
    return course.value?.exam
  })

  const passedStatusText = computed(() => {
    if (!examResult.value) return ''
    return examResult.value!.passed
      ? translateString('courses.examSimulation.passedExamText')
      : translateString('courses.examSimulation.notPassedExamText')
  })

  const hasSubjects = computed(() => {
    return CourseModule.examHasSubjects
  })

  const endExam = () => {
    router.push({ name: isKnowledgeCheckCompany.value ? 'KnowledgeCheckInfo' : 'ExamStartPage' }).catch(() => {
      return
    })
  }

  const startNewSimulation = () => {
    CourseModule.resetExamCompletionId()
    router.push({ name: 'CourseExamContent' }).catch(() => {
      return
    })
  }

  const fetchCourseAndExamResults = async () => {
    try {
      if (!course.value) {
        await CourseModule.getCourse({ courseId: currentCourseId.value })
      }
      fetchExamResults()
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  const fetchExamResults = () => {
    CourseModule.getExamResult(examCompletionIdParam.value)
  }

  fetchCourseAndExamResults()

  const passedExamGamificationActivityTracked = CookieHelper.getCookieValue('passed_exam_tracked')

  onMounted(() => {
    trackPage('Course Exam Results')
    pageViewed('Course Exam Results')
    if (examResult.value?.passed && !passedExamGamificationActivityTracked) {
      trackGamificationActivity('EXAM_PASSED', {
        courseId: currentCourseId.value,
        moduleId: null,
        lessonId: null,
      })
      CookieHelper.setCookieValue('passed_exam_tracked', 'true')
    }
  })

return { __sfc: true,router, course, currentCourseId, examCompletionIdParam, trackPage, pageViewed, trackGamificationActivity, translateString, isKnowledgeCheckCompany, loadingResults, examResult, courseExam, passedStatusText, hasSubjects, endExam, startNewSimulation, fetchCourseAndExamResults, fetchExamResults, passedExamGamificationActivityTracked, computed, onMounted, LoadingSpinner, KetchUpButton, HTMLRenderer, CourseModule, useCourse, CookieHelper, useSegment, useGamification, useRouter, useI18n, useCommonMixin, Sentry }
}

})